import { render } from "./reporte_prospectos.vue?vue&type=template&id=a1b1fdd8&scoped=true"
import script from "./reporte_prospectos.vue?vue&type=script&lang=js"
export * from "./reporte_prospectos.vue?vue&type=script&lang=js"

import "./reporte_prospectos.vue?vue&type=style&index=0&id=a1b1fdd8&scoped=true&lang=css"

import exportComponent from "D:\\Users\\felipecedillo\\Documents\\GitHub\\marbel-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1b1fdd8"]])

export default __exports__